export default __webpack_public_path__ + "static/media/icon_catalyst.db078b7b.png";